import {
    PAUSE_APP,
    RESUME_APP
} from './actionTypes'

export const pauseApp = () => ({
    type: PAUSE_APP
})

export const resumeApp = () => ({
    type: RESUME_APP
})
